import Termly from '@components/termly/Termly';
import { ContentBlock } from '@layouts/ContentBlocks';
import Typography from '@mui/material/Typography';
import { useStyles } from '@ui/utils/makeStyles';
import { makeSeoData } from 'config/next-seo.config';
import { NextSeo } from 'next-seo';
import React from 'react';

const title = 'Guest House Cookie Policy';
const description = 'At Guest House we value transparency. Here is the information you need on how we set cookies, what they are used for and what you can expect as a user.';

export default function Privacy() {
  const { theme } = useStyles();

  return (
    <>
      <NextSeo {...makeSeoData({ pageTitle: title, metaTitle:title, metaDescription: description })} />
      <ContentBlock
        margin={[2, 'auto', 3]}
        padding={0}
      >
        <Typography
          variant="h1"
          style={{ position: 'relative', top: 75, marginLeft: theme.spacing(3.5) }}
        >
          Cookie Policy
        </Typography>
        {process.browser && (
        <Termly id="7da5f87c-7574-40bb-9756-127543d87509" />
        )}
      </ContentBlock>
    </>
  );
}
